/*
 * @Author: DQL
 * @Date: 2020-03-20 11:18:19
 * @LastEditors: DQL
 * @LastEditTime: 2022-07-18 15:41:32
 * @Description: file content
 */

/* =============================================
   业务功能路由配置文件引入 Start
  *
  *
*/

// kTableList
import kTableListRoutes from '@/features/examples/kTableList/kTableList.routes.js';

/* 业务功能路由配置文件引入 End */

/* =============================================
   业务功能路由配置写入 Start
  *
  *
*/
const FEATURES_ROUTES = [
  kTableListRoutes
];

/* 业务功能路由配置写入 End */

// 路由配置=============================================
const examplesRoutes = {
  path: 'examples',
  name: 'examples',
  component: { template: '<router-view></router-view>' },
  children: [
    ...FEATURES_ROUTES
  ]
};

export default examplesRoutes;
